<!-- zsm.vue -->
<template>
	<div class="zsm-container">
		<!-- 筛选条件区域 -->
		<div class="filter-section">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item label="药品名称：">
					<el-input v-model="filterForm.drugName" placeholder="请输入药品名称" size="small" clearable
						style="width: 200px;" prefix-icon="el-icon-Ssearch" />
				</el-form-item>

				<!-- 药库类型下拉框 -->
				<el-form-item label="药库类型：">
					<el-select v-model="filterForm.warehouseType" placeholder="请选择药库类型" size="small" clearable
						style="width: 120px;" @change="handleWarehouseTypeChange">
						<el-option label="药库" :value="1"></el-option>
						<el-option label="药房" :value="3"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="small" @click="handleFilter" icon="el-icon-Ssearch">
						查询
					</el-button>
					<el-button size="small" @click="resetFilter">
						重置
					</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!-- 统计信息区域 -->
		<div class="stats-section">
			<el-tabs v-model="statsActiveTab" type="border-card">
				<el-tab-pane label="追溯码明细表" name="detail">
					<!-- 追溯码明细表内容 -->
					<div class="stats-content">
						<!-- 主表格 -->
						<div class="main-table-section">
							<div class="table-section">
								<div class="table-header">
									<div class="table-stats">
										<!-- 统计信息 -->
									</div>
								</div>

								<div class="table-container">
									<el-table :data="tableData" ref="singleTable" border stripe
										@row-dblclick="handledbRow" highlight-current-row
										@current-change="handleCurrentTableChange" v-loading="loading"
										style="width: 100%;" :height="tableHeight" :key="tableKey"
										:row-style="{height: '40px'}"
										:cell-style="{padding: '6px 0', fontSize: '12px'}">

										<el-table-column fixed="left" label="行号" type="index" width="60"
											align="center"></el-table-column>

										<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
											:prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"
											:align="col.nz ? 'center' : 'left'" show-overflow-tooltip>
										</el-table-column>

										<el-table-column fixed="right" label="操作" width="100" align="center">
											<template slot-scope="scope">
												<el-button type="text" size="mini"
													@click="handleTraceCodeDetail(scope.row)">
													追溯码明细
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>

								<!-- 分页 -->
								<div class="pagination-section">
									<el-pagination @size-change="handleSizeChange"
										@current-change="handleCurrentChange" :current-page="pageNum"
										:page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalSize"
										layout="total, sizes, prev, pager, next, jumper" background>
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>

		<!-- 流向记录对话框 -->
		<el-dialog :title="'【' + flowDialogTitle + '】' + '药品流向记录'" :visible.sync="flowdiglog" width="70%" top="8vh"
			:before-close="flowhandleClose" class="flow-dialog">

			<div class="dialog-header" style="display: flex; align-items: center; flex-wrap: wrap; gap: 10px; margin-bottom: 15px;">
				<!-- 新增：供应商字段 -->
				<span style="font-weight: bold; color: #303133; margin-right: 15px;">
					供应商: <span style="color: #409eff;">{{ supplyName || '' }}</span>
				</span>

				<span>业务日期:</span>
				<el-date-picker v-model="startDate" type="datetime" size="small" style="width: 180px;"
					placeholder="选择开始时间" :picker-options="pickerOptions" @change="startDateHandle"
					value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
				<el-date-picker v-model="endDate" type="datetime" style="width: 180px;" size="small"
					placeholder="选择结束时间" :picker-options="pickerOptions" @change="endDateHandle"
					value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
				<!-- 修改：刷新按钮改为查询按钮 -->
				<el-button size="small" type="primary" plain @click="changeData" icon="el-icon-Ssearch">
					查询
				</el-button>
			</div>

			<div class="dialog-table">
				<el-table :data="innertableData" v-loading="loading" ref="singleTable" border
					@row-dblclick="handledbRow" highlight-current-row @current-change="handleCurrentTableChange"
					height="400" :row-style="{height: '40px'}"
					:cell-style="{padding: '6px 0', fontSize: '12px'}">
					<el-table-column prop="bizSoucName" label="业务来源" width="120" align="center"></el-table-column>
					<el-table-column prop="chgCnt" label="库存变化数量" width="160" show-overflow-tooltip></el-table-column>

					<el-table-column v-for="(col, inx) in innertableDataRows" :key="inx" :type="col.type"
						:prop="col.prop" :label="col.name" :width="flowdiglogColumnWidth(col, innertableData)"
						align="center">
					</el-table-column>
				</el-table>
			</div>

			<div class="dialog-pagination" style="margin-top: 15px;">
				<el-pagination @size-change="innerHandleSizeChange" @current-change="innerHandleCurrentChange"
					:current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="innerPageSize"
					:total="innerTotolSize" layout="total, sizes, prev, pager, next, jumper" background size="small">
				</el-pagination>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dy">打印</el-button>
				<el-button size="small" @click="flowdiglog = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// 导入ECharts
	import * as echarts from 'echarts';
	import printUtil from "@/untils/printUtil";
	import {
		Winvent
	} from "@/assets/printTemplateConfig/Winvent";
	// 修改：移除getInventPage，使用barcodePageList
	import {
		barcodePageList,barcodeChgDetail
	} from "@/api/PSI/DrugInventory.js";
	// 调价相关接口
	import {
		chgDetailsPage,
		adjustFastPric
	} from "@/api/PSI/ChangeDetailsTable.js";
	// 导入库存预警相关接口
	import {
		alertList,
		alertPages,
		alert
	} from "@/api/PSI/westernWarning.js";
	// 药品剂型相关
	import {
		getDosageForm
	} from "@/api/PSI.js";

	export default {
		name: 'Zsm',
		props: {
			// 接收父组件传递的库存类型
			inventoryType: {
				type: String,
				default: 'western'
			}
		},
		data() {
			return {
				// 统计信息选项卡
				statsActiveTab: 'detail',
				// 筛选条件数据 - 新增 warehouseType
				filterForm: {
					drugName: '',
					dosform: '',
					dateRange: [],
					warehouseType: 1, // 默认药库(1)
				},
				
				// 统计信息数据
				totalStock: '0',
				totalInventoryCount: 0,
				totalCost: '0.00',
				currentPageTotalStock: '0',
				// 表格数据
				tableHeight: 400,
				pageNum: 1,
				pageSize: 10,
				totalSize: 0,
				tableData: [],
				tableKey: Date.now(),
				
				// 对话框控制
				flowdiglog: false,
				flowDialogTitle: '',
				supplyName: '', // 新增：记录流向记录中的供应商名称

				// 其他数据
				startDate: '',
				endDate: '',
				flowId: '',
				manuLotnum: '',
				loading: false,
				innerPageSize: 10,
				innerTotolSize: 20,
				currentTable: {},
				innertableData: [],

				// 映射数据（添加更多映射）
				drugTypeMap: {
					1: '西药',
					2: '成药',
					3: '卫材',
					4: '血液',
					5: '疫苗'
				},
				dosformMap: {
					'片剂': '片剂',
					'胶囊': '胶囊',
					'注射液': '注射液',
					'颗粒剂': '颗粒剂',
					'软膏': '软膏'
				},
				// 映射数据
				shedIdMap: {
					1: '西药库',
					2: '中药库',
					3: '西药房',
					4: '中药房'
				},
				bizMap: {
					1: '采购入库',
					2: '其他入库',
					3: '冲销入库',
					4: '调拨出库',
					5: '出库',
					6: '盘点入库',
					7: '盘点反结转入库',
					8: '发药入库',
					9: '退药入库',
					10: '调拨入库',
				},
				bizColorMap: {
					1: '#67C23A',
					2: '#409EFF',
					3: '#F56C6C',
					4: '#FF6700',
					5: '#aa0000',
					6: '#F56C6C',
					7: '#FF6700',
					8: '#67C23A',
					9: '#aa0000'
				},
				statusMap: {
					1: '追溯码',
					2: '成药',
					3: '卫材',
					4: '血液',
					5: '疫苗'
				},
				
				// 表格列配置
				tableRows: [{
						name: "药品名称",
						prop: "drugName",
						type: ""
					},
					{
						name: "药品追溯码",
						prop: "barcode",
						type: ""
					},
					{
						name: "追溯码库存ID",
						prop: "barcodeTableId",
						type: ""
					},
					{
						name: "生产批次号",
						prop: "manuLotnum",
						type: ""
					},
					{
						name: "库存数量",
						prop: "barCnt",
						type: ""
					},
					{
						name: "包装数量",
						prop: "pacCnt",
					},

				],
				// 流向记录表格列配置（新增患者）
				innertableDataRows: [
					{
						name: "变化数量",
						prop: "chgCnt",
						type: ""
					},
					{
						name: "变化前库",
						prop: "agoCnt",
						type: ""
					},
					{
						name: "变化后库",
						prop: "afrCnt",
						type: ""
					},
					{
						name: "操作人",
						prop: "createName",
						type: ""
					},
					{
						name: "患者", // 新增字段
						prop: "patientName", // 请根据后端返回实际字段名修改，例如 dispenserName
						type: ""
					},
					{
						name: "创建时间",
						prop: "createTime",
						type: ""
					},
				],

				pickerOptions: {
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '去年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						}
					]
				}
			};
		},
		watch: {
			// 监听库存类型变化，重新加载数据
			inventoryType: {
				immediate: true,
				handler(newVal) {
					this.loadData(); // loadData中已经包含传递逻辑
				}
			}
		},

		mounted() {
			this.loadData(); // 初始加载数据
			this.getDateTime();
			this.calculateTableHeight();
			this.$nextTick(() => {
				window.addEventListener('resize', this.calculateTableHeight);
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calculateTableHeight);
		},
		methods: {
			// 药库类型切换处理
			handleWarehouseTypeChange() {
				this.pageNum = 1;
				this.loadData();
			},

			// 加载数据方法
			async loadData() {
				this.loading = true;
				try {
					// 修改：使用barcodePageList接口，type参数动态使用 warehouseType
					let params = {
						drugName: this.filterForm.drugName,
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						type: this.filterForm.warehouseType, // 动态传递药库类型
					};
					console.log('调用barcodePageList接口参数:', params);
					let res = await barcodePageList(params);

					if (res.code === 200) {
						this.tableData = res.data.content || res.data || [];
						this.totalSize = res.data.totalSize || 0;
						this.totalInventoryCount = this.calculateTotalInventoryCount(this.tableData);

						// 立即向父组件传递库存数量
						this.$emit('count-update', {
							type: this.inventoryType,
							count: this.totalInventoryCount
						});

						this.updateStatistics();

						this.$nextTick(() => {
							this.forceTableRerender();
						});
					} else {
						this.$message.error(res.message || '获取数据失败');
						this.tableData = [];
					}
				} catch (error) {
					this.$message.error('请求出错: ' + error.message);
					this.tableData = [];
				} finally {
					this.loading = false;
				}
			},

			// 计算总库存数量
			calculateTotalInventoryCount(tableData) {
				if (!tableData || tableData.length === 0) {
					return 0;
				}

				// 根据实际业务逻辑计算总库存数量
				// 这里假设使用allRealCnt字段，您可以根据实际情况调整
				return tableData.reduce((total, item) => {
					return total + (Number(item.allRealCnt) || 0);
				}, 0);
			},

			// 强制表格重新渲染
			forceTableRerender() {
				this.tableKey = Date.now();
			},

			// 更新统计信息方法
			updateStatistics() {
				if (this.tableData.length > 0) {
					// 当前页库存总数（用于页面显示）
					const pageStock = this.tableData.reduce((sum, item) => sum + (Number(item.allPurcAmt) || 0), 0);
					const totalCost = this.tableData.reduce((sum, item) => sum + parseFloat(item.allSaleAmt || 0), 0);

					this.currentPageTotalStock = pageStock.toLocaleString();
					this.totalCost = totalCost;

					// 计算总库存数量（用于传递给父组件）
					this.totalInventoryCount = this.calculateTotalInventoryCount(this.tableData);
				} else {
					this.currentPageTotalStock = '0';
					this.totalCost = '0.00000000';
					this.totalInventoryCount = 0;
				}
			},

			// 处理查询
			handleFilter() {
				this.pageNum = 1;
				this.loadData();
			},

			// 重置筛选条件
			resetFilter() {
				this.filterForm = {
					drugName: '',
					dosform: '',
					dateRange: [],
					warehouseType: 1, // 重置时恢复为西药库(1)
				};
				this.pageNum = 1;
				this.loadData();
			},

			// 分页处理
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.loadData();
			},

			handleCurrentChange(val) {
				this.pageNum = val;
				this.loadData();
			},

			// 计算表格高度
			calculateTableHeight() {
				const windowHeight = window.innerHeight;
				const otherHeight = 500;
				this.tableHeight = Math.max(400, windowHeight - otherHeight);
			},

			// 获取药品类型标签样式
			getDrugTypeTagType(type) {
				const typeMap = {
					1: 'success',
					2: 'warning',
					3: 'info',
					4: 'danger',
					5: 'primary'
				};
				return typeMap[type] || 'info';
			},

			// 点击追溯码明细按钮，直接打开流向记录对话框
			handleTraceCodeDetail(row) {
				console.log('追溯码明细参数:', {
					row,
					barcodeTableId: row.barcodeTableId || row.id, // 使用barcodeTableId或id
				});

				this.flowDialogTitle = row.drugName || '药品';
				this.flowdiglog = true;
				this.flowId = row.barcodeTableId || row.id; // 使用barcodeTableId
				this.manuLotnum = row.manuLotnum;
				
				// 重置供应商名称
				this.supplyName = '';

				// 重置流向记录分页参数
				this.pageNum = 1;
				this.pageSize = 10;

				this.getFlowData();
			},

			// 获取流向数据，使用barcodeChgDetail接口
			async getFlowData() {
				if (!this.flowId) {
					this.$message.error('缺少追溯码库存ID参数');
					return;
				}

				try {
					this.loading = true;

					// 构建正确的参数对象
					let params = {
						barcodeTableId: this.flowId, // 追溯码库存id
						pageNum: this.pageNum, // 当前页码
						pageSize: this.pageSize, // 每页大小
					};

					console.log('调用barcodeChgDetail接口参数:', params);

					let res = await barcodeChgDetail(params);

					if (res.code === 200) {
						this.innertableData = res.data.content || res.data;
						this.innerTotolSize = res.data.totalSize || (res.data.content ? res.data.content.length : 0);
						
						// 提取供应商名称
						if (this.innertableData.length > 0) {
							this.supplyName = this.innertableData[0].supplyName || this.innertableData[0].supplierName || '';
						}

						this.$message.success('获取流向记录成功');
					} else {
						this.$message.error(res.message || '获取流向记录失败');
					}
				} catch (error) {
					console.error('获取流向记录出错:', error);
					this.$message.error('获取流向记录出错: ' + error.message);
				} finally {
					this.loading = false;
				}
			},

			// 获取当前时间
			getDateTime() {
				const today = new Date();
				const startDate = new Date(today);
				startDate.setHours(0, 0, 0, 0);
				this.startDate = this.formatDateTime(startDate);

				const endDate = new Date(today);
				endDate.setHours(23, 59, 59, 999);
				this.endDate = this.formatDateTime(endDate);
			},

			// 格式化日期时间
			formatDateTime(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			// 处理统计信息选项卡点击
			handleStatsTabClick(tab) {
				console.log('切换到统计信息标签:', tab.name);
			},

			// 流向记录分页大小改变
			innerHandleSizeChange(val) {
				this.innerPageSize = val;
				this.pageNum = 1;
				this.getFlowData();
			},

			// 流向记录当前页改变
			innerHandleCurrentChange(val) {
				this.pageNum = val;
				this.getFlowData();
			},

			// 其他方法保持不变...
			handledbRow(row, column, event) {
				// console.log(this.addForm);
			},

			handleCurrentTableChange(val) {
				this.currentTable = val;
			},

			changeData() {
				this.getFlowData();
			},

			// 列宽计算等方法保持不变...
			// col 里面包含了表头字段和名称，list 是表格数据
			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 20; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 12; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 8;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 12;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 数字
						else if (Number.isFinite(Number(char))) length += 8;
						// 中文字符 28px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 26;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},

			flowdiglogColumnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 28; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 20; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 12;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 8;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 数字
						else if (Number.isFinite(Number(char))) length += 12;
						// 中文字符 28px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 22;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},

			// 表格底部循环按钮事件
			feetHandClick(i) {
				// i event
				switch (i) {
					case 0:
						// 高亮显示选中的行
						this.$nextTick(() => {
							const table = this.$refs.singleTable;
							if (table) {
								table.setCurrentRow(this.currentTable);
							}
						});
						break;
					case 1:
						// 流向记录
						this.$message({
							type: 'warning',
							message: '流向记录'
						});
						break;
					case 2:
						// this.handlePrint();
						break;
					case 3:
						this.$message({
							type: 'warning',
							message: '暂未开放，敬请期待。'
						});
						break;
				}
			},

			// 修改流向记录按钮点击逻辑
			XQfeetHandClick(v) {
				console.log(v, '日期调整等按钮');
				if (v.title == '档案信息' || v.title.includes('档案信息')) {
					this.$message({
						type: 'warning',
						message: '档案信息'
					});
				} else if (v.title == '流向记录' || v.title.includes('流向记录')) {
					// 确保有选中行
					if (!this.TZXQcurrentTable || Object.keys(this.TZXQcurrentTable).length === 0) {
						this.$message.warning('请先选择一条批次数据');
						return;
					}

					// 直接从当前选中行获取值
					this.manuLotnum = this.TZXQcurrentTable.manuLotnum;
					this.flowId = this.TZXQcurrentTable.id;
					this.flowDialogTitle = this.TZXQcurrentTable.drugName;
					this.flowdiglog = true;
					this.getFlowData();
				} else if (v.title == '打印' || v.title.includes('打印')) {
					if (!this.innertableData || this.innertableData.length === 0) {
						this.$message.warning('没有可打印的流向记录数据');
						return;
					}
					this.handlePrint();
				} else if (v.title == '关闭' || v.title.includes('关闭')) {
					this.XQdialogVisible = false;
				}
			},
			dy() {
				const printData = this.planMedicalRecord();
				console.log('打印数据:', printData); // 调试用
				printUtil.init(Winvent);
				printUtil.print(printData);
			},
			// 打印相关
			printMedicalRecord() {
				// 初始化hiprint打印模板
				const template = new hiprint.PrintTemplate({
					template: Winvent, // 使用Wstore模板
					data: this.planMedicalRecord() // 传入打印数据
				});

				// 执行打印
				template.print();
			},

			previewMedicalRecord() {
				// 初始化hiprint打印模板
				const template = new hiprint.PrintTemplate({
					template: Winvent, // 使用Winvent模板
					data: this.planMedicalRecord() // 传入打印数据
				});

				// 执行预览
				template.preview();
			},

			// 开始时间变化值
			startDateHandle(value) {
				if (value) {
					// 使用 JavaScript 的 Date 对象格式化日期
					this.startTime = value
					console.log(this.startTime, 'startTimestartTimestartTime');
				} else {
					this.startTime = '';
				}
			},
			// 结束时间变化值
			endDateHandle(value) {
				if (value) {
					// 使用 JavaScript 的 Date 对象格式化日期
					this.endTime = value
				} else {
					this.endTime = '';
				}
			},

			planMedicalRecord() {
				// 首先检查是否有可打印的数据
				if (!this.innertableData || this.innertableData.length === 0) {
					this.$message.warning('没有可打印的流向记录数据');
					return null; // 返回null表示无法打印
				}

				// 获取当前时间并格式化为yyyy-MM-dd HH:mm:ss
				const formatCurrentTime = () => {
					const now = new Date();
					const year = now.getFullYear();
					const month = String(now.getMonth() + 1).padStart(2, '0');
					const day = String(now.getDate()).padStart(2, '0');
					const hours = String(now.getHours()).padStart(2, '0');
					const minutes = String(now.getMinutes()).padStart(2, '0');
					const seconds = String(now.getSeconds()).padStart(2, '0');
					return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				};

				// 准备流向记录的打印数据
				const printData = {
					// 头部信息 - 对应Winvent.json中的顶部文本元素
					flowDialogTitle: this.flowDialogTitle || '药品流向记录', // 对话框标题
					nowDateTime: formatCurrentTime(), // 使用格式化后的当前时间

					// 表格数据 - 必须与Winvent模板中的字段完全匹配
					tableData: this.innertableData.map((item, index) => ({
						rowNum: index + 1, // 行号 - 对应"行号"列
						sysNum: item.id || '', // 系统序号 - 对应"系统序号"列
						drugName: item.drugName || this.flowDialogTitle || '', // 药品名称 - 对应"药品名称"列
						storage: this.shedIdMap[item.shedId] || '未知', // 入库库房 - 对应"入库库房"列
						source: this.bizMap[item.bizSouc] || '未知', // 业务来源 - 对应"业务来源"列
						changeQty: item.chgCnt || 0, // 变化数量 - 对应"变化数量"列
						beforeQty: item.agoCnt || 0, // 变化前库 - 对应"变化前库"列
						afterQty: item.afrCnt || 0, // 变化后库 - 对应"变化后库"列
						// 以下为Winvent.json中定义但原方法未包含的字段
						unt: item.unt || '', // 计量单位
						purcPric: item.purcPric || 0, // 成本单价
						salePric: item.salePric || 0, // 零售单价
						drugSpec: item.drugSpec || '', // 药品规格
						prodentpName: item.prodentpName || '', // 生产厂家
						manuLotnum: item.manuLotnum || '' // 生产批号
					})),

					// 底部信息 - 对应Winvent.json中的底部文本元素
					businessDate: `${this.startDate} 至 ${this.endDate}`, // 业务日期范围
					operator: this.userInfo.userName || '未知', // 操作人
					reviewer: '系统审核' // 过单人
				};

				return printData;
			},

			// input 
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						this.$refs['addForm'].resetFields();
						done();
					})
					.catch(_ => {

					});
			},
			XQhandleClose(done) {
				this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 重置相关数据
					this.XQtableData = [];
					this.TZXQcurrentTable = {};
					this.XQdialogVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},
			TZXQhandleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						// this.$refs['addForm'].resetFields();
						done();
					})
					.catch(_ => {

					});
			},
			flowhandleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			// db events
			// 步骤
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// 处理索引0的逻辑 => 刷新
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.$message({
								type: 'success',
								message: '已刷新'
							})
							this.loading = false;
						}, 1500)
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
				}
			},
			// 打印按钮点击事件
			async handlePrint() {
				if (!this.innertableData || this.innertableData.length === 0) {
					this.$message.warning('没有可打印的流向记录数据');
					return;
				}

				this.$confirm('请选择打印方式', '打印设置', {
					confirmButtonText: 'Lodop打印',
					cancelButtonText: '浏览器打印',
					type: 'warning'
				}).then(() => {
					// 用户选择Lodop打印
					const printData = this.planMedicalRecord();
					console.log('打印数据:', printData);
					printUtil.init(Winvent);
					printUtil.print(printData);
				}).catch(() => {
					// 用户选择浏览器打印
					const printData = this.planMedicalRecord();
					printUtil.init(Winvent);
					printUtil.preview(printData);
				});
			},
			// 使用Lodop打印并设计
			printWithLodop() {
				this.$router.push({
					path: '/PrintTemplateDesigner',
					query: {
						tableData: JSON.stringify(this.tableData),
						currentTable: JSON.stringify(this.tableData),
						templateName: '【追溯码库】药品库存清单'
					}
				});
			},
			// 实时宽度
			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 228;
			}
		}
	};
</script>

<style lang="less" scoped>
	.zsm-container {
		height: 100%;
		padding: 20px;
		display: flex;
		flex-direction: column;
	}

	/* 主表格区域 */
	.main-table-section {
		width: 100%;
		transition: width 0.3s ease;
	}

	/deep/ .el-dialog {
		max-height: 90vh;
		display: flex;
		flex-direction: column;

		.el-dialog__body {
			flex: 1;
			overflow-y: auto;
			padding: 20px;
		}

		&__header {
			background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
			padding: 12px 20px;
			border-bottom: 1px solid #e6e6e6;
			display: flex;

			.el-dialog__title {
				color: #fff;
				font-size: 16px;
				font-weight: bold;
			}
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}

		.el-dialog__headerbtn .el-dialog__close:hover {
			color: #f80000;
		}
	}

	/* 表格区域通用样式 */
	.table-section {
		background: #fff;
		border-radius: 8px;
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		.table-header {
			padding: 16px;
			border-bottom: 1px solid #ebeef5;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-shrink: 0;

			.table-stats {
				display: flex;
				gap: 40px;

				.table-stat-item {
					display: flex;
					align-items: center;
					gap: 8px;

					.stat-label {
						font-size: 14px;
						color: #606266;
						font-weight: 500;
					}

					.stat-value {
						font-size: 16px;
						font-weight: bold;
						color: #409EFF;
					}
				}
			}
		}

		.table-container {
			flex: 1;
			overflow: hidden;
		}

		.pagination-section {
			padding: 16px;
			border-top: 1px solid #ebeef5;
			background: #fafbfc;
		}
	}

	/* 调整表格字体大小和行高 */
	/deep/ .el-table {
		font-size: 12px;
		
		.el-table__row {
			height: 40px;
		}
		
		.el-table__cell {
			padding: 6px 0;
			
			.cell {
				line-height: 1.5;
			}
		}
	}
	
	/* 对话框中的表格也调整 */
	/deep/ .flow-dialog .el-table {
		font-size: 12px;
		
		.el-table__row {
			height: 40px;
		}
		
		.el-table__cell {
			padding: 6px 0;
			
			.cell {
				line-height: 1.5;
			}
		}
	}

	/* 滚动条优化 */
	.table-container ::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.table-container ::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	.table-container ::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;

		&:hover {
			background: #a8a8a8;
		}
	}
</style>